<nz-affix [nzOffsetTop]="0">
  <hx-breadcrumbs></hx-breadcrumbs>
  <nz-page-header nzBackIcon [nzGhost]="false">
    <nz-page-header-title>{{(isEdit ? 'action.edit' : 'action.create') | transloco}}</nz-page-header-title>
  </nz-page-header>
</nz-affix>

<nz-skeleton [nzActive]="true" [nzLoading]="isLoading.model" *transloco="let tr; prefix: 'brands'; scope: 'brands'">
  <form class="hx-form" nz-form [nzLayout]="'vertical'" [formGroup]="form" (ngSubmit)="submitForm()">
    <div nz-row [nzGutter]="8">
      <div nz-col class="hx-col-2">
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('form.title')}}</nz-form-label>
          <nz-form-control>
            <input nz-input formControlName="title"/>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <nz-alert *ngIf="form.invalid" nzType="error" [nzMessage]="'error.fillRequiredFields' | transloco" nzShowIcon></nz-alert>

    <div nz-row [nzGutter]="8" class="cp_actions">
      <div nz-col>
        <nz-form-item>
          <nz-form-control>
            <button [nzLoading]="isSaving" [disabled]="form.pristine || form.pending" type="submit" nz-button nzType="primary">
              <i nz-icon nzType="save" nzTheme="outline"></i> {{'button.save' | transloco}}
            </button>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col>
        <nz-tag nzColor="success" *ngIf="form.pristine && model.id">
          <i nz-icon nzType="check-circle"></i>
          <span>{{'form.saved' | transloco}}</span>
        </nz-tag>
      </div>
    </div>
  </form>

  <ng-container *ngIf="model.id">
    <nz-divider [nzDashed]="true" [nzText]="tr('form.brandTitles')" nzOrientation="left"></nz-divider>

    <nz-affix [nzOffsetTop]="0">
      <nz-page-header [nzGhost]="false">
        <nz-page-header-extra>
          <button type="button" nzSize="large" nz-button nzType="dashed" (click)="addBrandTitle()">
            <i nz-icon nzType="plus-circle" nzTheme="twotone"></i> {{ tr('button.addNewTitle') }}
          </button>
        </nz-page-header-extra>
      </nz-page-header>
    </nz-affix>

    <nz-table [nzLoading]="isTableLoading" #listTable
              [nzTotal]="total"
              [nzPageSize]="limit"
              [nzPageIndex]="page"
              [nzData]="list"
              (nzQueryParams)="onQueryParamsChange($event)"
              [nzFrontPagination]="false">
      <thead>
      <tr>
        <th nzColumnKey="id">{{ tr('column.id') }}</th>
        <th nzColumnKey="createDate">{{ tr('column.createDate') }}</th>
        <th nzColumnKey="title">{{ tr('column.title') }}</th>
        <th nzColumnKey="countryName">{{ tr('column.countryName') }}</th>
        <th nzColumnKey="brandTitle">{{ tr('column.brandTitle') }}</th>
        <th nzWidth="100px">#</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let data of list">
        <td>{{ data.id }}</td>
        <td>{{ data.createDate | date: 'dd.MM.yyyy' }}</td>
        <td>{{ data.title | json }}</td>
        <td>{{ data.country?.title | uiLabel }}</td>
        <td>{{ data.brand?.title }}</td>
        <td>
          <nz-button-group>
            <a (click)="editBrandTitle(data.id)" nz-button nzType="primary">
              <i nz-icon nzType="edit" nzTheme="outline"></i>
            </a>
            <button nz-button nzType="default" nzDanger nz-popconfirm
                    [nzPopconfirmTitle]="'remove.popconfirm' | transloco" [nzOkText]="'yes' | transloco"
                    [nzCancelText]="'no1' | transloco"
                    (nzOnConfirm)="remove(data.id)">
              <i nz-icon nzType="delete" nzTheme="outline"></i>
            </button>
          </nz-button-group>
        </td>
      </tr>
      </tbody>
    </nz-table>
  </ng-container>

</nz-skeleton>
